import {articleService} from '../../services/service-factory';

export default {
  data: function() {
    return {
      articleService: undefined
    };
  },
  created: function() {
    this.articleService = articleService;
  }
};
